export const callrailSwap = () => {
  if (
    typeof window !== `undefined` &&
    typeof window.CallTrk !== `undefined` &&
    window.CallTrk.swap &&
    typeof window.CallTrk.swap === `function`
  ) {
    window.CallTrk.swap();
  }
}